import React, { useState, useEffect, ChangeEvent } from 'react';
import appleLogo from './assets/applelogo.png';

const AccessInstructionsPage: React.FC = () => {
  return (
    <div>
      <div className="login-page">
        <div className="header-container">
          <div className="header-login">
            <img src={appleLogo} alt="Apple Logo" className="logo" />
            <h2>Performance Operations Hub</h2>
          </div>
          <div className="login-container">
            <h2>Access Denied</h2>
            <p>Our records indicate that you do not have access to this application in Okta. <br /><br />Please email michael.couch@omcpmg.com with your name, agency, and team and he can help to grant access to this application.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessInstructionsPage;
